'use client'

import { Card, Spacer } from '@vinted/web-ui'

import { ComponentLocation } from '../../observability/constants'
import Auth from '../../components/Auth'

const SelectLoginType = () => {
  return (
    <>
      <Spacer size="x2-large" />
      <div className="auth__container">
        <Card>
          <Spacer size="x2-large" />
          <Auth componentLocation={ComponentLocation.AuthenticationPage} />
        </Card>
      </div>
    </>
  )
}

export default SelectLoginType
